import React, { Fragment } from "react";
import {
  Hero,
  Heading,
  Container,
  Columns,
  Content,
  Tile,
  Section
} from "react-bulma-components";
import JobDetailsTable from "./JobDetailsTable";
import JobStatsCard from "./JobStatsCard";
import AnonymousView from "./AnonymousView";
import JobHeader from "./JobHeader";
import JobDescription from "./JobDescription";
import { BREAKPOINTS, COLORS } from "../../constants";
import { displayCurrency } from "../../utils";

const JobDetailView = ({ job }) => {
  return (
    <Fragment>
      <Section className="job">
        <Columns>
          <Columns.Column size="half" offset={3}>
            <JobHeader job={job} linkHeader={false} />
            <br />
            {job.bounty > 0 && (
              <Hero color={COLORS.PRIMARY} gradient>
                <Hero.Body>
                  <Heading>
                    Refer a friend and earn{" "}
                    {displayCurrency(job.bounty, job.bountyCurrency)}
                  </Heading>
                  Scroll down for details
                </Hero.Body>
              </Hero>
            )}
            <br />
            <Content>
              <Heading size={5}>Details</Heading>
              <JobDetailsTable job={job} />
            </Content>
            <br />
            <Content>
              <JobDescription job={job} />
            </Content>
            <br />
            {job.bounty > 0 && <AnonymousView job={job} />}
          </Columns.Column>
        </Columns>
      </Section>
    </Fragment>
  );
};

export default JobDetailView;